import Store from './store';
import Base64 from './base64';
import { notification } from 'antd';
import moment from 'moment';
import nls from './properties';
var Utils = {};

Date.prototype.Format = function(fmt){
  var o = {
    "M+" : this.getMonth()+1,                 //月份
    "d+" : this.getDate(),                    //日
    "H+" : this.getHours(),                   //小时
    "m+" : this.getMinutes(),                 //分
    "s+" : this.getSeconds(),                 //秒
    "q+" : Math.floor((this.getMonth()+3)/3), //季度
    "S"  : this.getMilliseconds()             //毫秒
  };
  if(/(y+)/.test(fmt))
    fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));
  for(var k in o)
    if(new RegExp("("+ k +")").test(fmt))
  fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
  return fmt;
}

// new Date() 兼容IE
Object.defineProperty(Utils, 'newDate', {
	value: function(str) {
    if (!str) {
      return new Date();
    } else if (typeof str == 'string') {
      return new Date(Date.parse(str.replace(/-/g,"/")));
    } else {
      return new Date(str);
    }
	}
});

Object.defineProperty(Utils, 'dateParse', {
	value: function(str) {
		return Date.parse(str.replace(/-/g,"/"));
	}
});

Object.defineProperty(Utils, 'getChannelMenu', {
	value: function(band) {
    var channelArr = [];
    if (!band) {
      return;
    }
    if (band == 2) {
      for (var i = 0; i < 14; i++) {
        channelArr.push(i + 1);
      }
    }else if (band == 5) {
      for (var i = 17; i < 32; i++) {
        channelArr.push((i + 1) * 2);
      }
      for (var i = 0; i < 30; i++) {
        if (i < 23) {
          channelArr.push(100 + i * 2);
        }else {
          channelArr.push(149 + (i - 23) * 2);
        }
      }
      var arr = [165, 183, 184, 185, 187, 188, 189, 192, 196];
      for (var i = 0; i < arr.length; i++) {
        channelArr.push(arr[i]);
      }
    }
    return channelArr;
	}
});


Object.defineProperty(Utils, 'generateUuid', {
	value: function(len) {
    // var len = 32; //32长度
    var radix = 16; //16进制
    var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
    var uuid = [],
        i;
    radix = radix || chars.length;
    if (len) {
        for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
    } else {
        var r;
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
        uuid[14] = '4';
        for (i = 0; i < 36; i++) {
            if (!uuid[i]) {
                r = 0 | Math.random() * 16;
                uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
            }
        }
    }
    return uuid.join('');
	}
});

Object.defineProperty(Utils, 'verifyIpAddress', {
	value: function(ip, key) {
		var re = null;
		if (!key) {
			re=/^(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9])\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[0-9])$/;
		} else {
			switch (key) {
				case 1:
					re = /^(10.100.10.(25[0-4]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[2-9]))$/;
					break;
				case 2:
					re = /^(10.100.11.(25[0-4]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[2-9]))$/;
					break;
				case 3:
					re = /^(10.100.12.(25[0-4]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[2-9]))$/;
					break;
				case 4:
					re = /^(10.100.13.(25[0-4]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[2-9]))$/;
					break;
				case 5:
					re = /^(10.100.14.(25[0-4]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[2-9]))$/;
					break;
				default:

			}
		}
		// console.log(re.test(ip));
    return re.test(ip);
	}
});

Object.defineProperty(Utils, 'formatDateTimeString', {
	value: function(date) {
    if (date) {
      date = new Date(date);
    }else {
      date = new Date();
    }
    date = date.toDateString() + ' ' + date.toTimeString().split(' ')[0];
		return date;
	}
});

Object.defineProperty(Utils, 'getFileIcon', {
	value: function(type) {
		var icon = 'file-text';
    switch (type) {
      case 'HTML':
        icon = 'file-code'
        break;
      default:
        break;
    }
    return icon;
	}
});
//后台自定义接口，数据层数据获取出错误弹出信息
Object.defineProperty(Utils, 'customInterfaceInfo', {
   value: function(err){
       var showinfo =  Store.get("showinfo");
       if(err.status == 500){
          if(err.responseJSON){
            if(err.responseJSON.error.message.value){
              if(err.responseJSON.error.message.value == "token invalid."){
                  //token 过期
									Store.set("showinfo",1);
									Store.set("token", '');
									openNotificationWithIcons('系统提示', '认证过期', 'error');
									document.location.reload();
              }else{
								openNotificationWithIcons('错误提示', err.responseJSON.error.message.value, 'error');
              };
            }else{
							openNotificationWithIcons('错误提示', err.statusText, 'error');
            }
          };
        }else if(err.status == 0){
          //连接服务器失败
          // alert("服务器连接失败。");
          // if(showinfo == 0){
            //设置是否弹出显示，认证过期或服务器连接失败窗口；0 可以显示 1 不显示
          Store.set("showinfo",1);
					openNotificationWithIcons('系统提示', "服务器连接失败。", 'error');
          // };
        } else if(err.status)  {
          Store.set("showinfo",1);
					openNotificationWithIcons('系统提示', "服务器错误。" + err.statusText, 'error');
        }
    }
});
//获取出错误弹出信息
Object.defineProperty(Utils, 'parseResponseErrorInfo', {
   value: function(err, callback){
       var showinfo =  Store.get("showinfo");
       if(err.status == 500){
          if(err.responseJSON){
            if(err.responseJSON.error.message.value){
              if(err.responseJSON.error.message.value == "token invalid."){
                  //token 过期
                  if(showinfo == 0){
                    //设置是否弹出显示，认证过期或服务器连接失败窗口；0 可以显示 1 不显示
										callback && callback('认证过期。');
                  };
              }else{
								callback && callback(err.responseJSON.error.message.value);
              };
            }else{
              //alert(err.statusText);
              // setTimeout(function(){
              //   document.getElementById('errmessagecontent').innerHTML = err.statusText;
              //   $('#errMessageModel').modal('show');
              // },200);
							// openNotificationWithIcons('错误提示', err.statusText, 'error');
            }
          };
        }else if(err.status == 0){
          //连接服务器失败
          // alert("服务器连接失败。");
          if(showinfo == 0){
            //设置是否弹出显示，认证过期或服务器连接失败窗口；0 可以显示 1 不显示
						callback && callback("服务器连接失败。");
          };
        };
    }
});

//oData接口，数据层数据获取出错误弹出信息
Object.defineProperty(Utils, 'oDataInterfaceInfo', {
   value: function(err){
      var showinfo =  Store.get("showinfo");
      if(err.response && err.response.statusCode == 500){
          var bodyinfo = '[';
          bodyinfo = bodyinfo + err.response.body+']';
          if(bodyinfo){
            bodyinfo = eval(bodyinfo);
            if(bodyinfo[0].error.message.value){
              if(bodyinfo[0].error.message.value == "token invalid."){
                //token 过期
                Store.set("showinfo",1);
                Store.set("token", '');
                openNotificationWithIcons('系统提示', '认证过期', 'error');
                document.location.reload();
              }else {
                openNotificationWithIcons('错误提示', err.responseJSON.error.message.value, 'error');
              };
            }else{
              //alert(err.response.statusText);
              setTimeout(function(){
                document.getElementById('errmessagecontent').innerHTML = err.response.statusText;
                $('#errMessageModel').modal('show');
              },200);
            }
          };
       }
       else if(err.response && err.response.statusCode == 0){
          //连接服务器失败
          Store.set("showinfo",1);
					openNotificationWithIcons('系统提示', "服务器连接失败。", 'error');
       };
    }
});

let invalidCount = 0;
Object.defineProperty(Utils, 'showInterfaceErrorInfo', {
   value: function(res){
     if (res.errmsg == 'token invalid.') {
       if (!invalidCount) {
         openNotificationWithIcons("系统提示", "认证失效，请重新登录。", 'error');
         location.href = '#/login';
       }
       invalidCount ++;
     } else if (res.errmsg) {
       invalidCount = 0;
       openNotificationWithIcons("系统提示", res.errmsg, 'error');
     } else {
       invalidCount = 0;
       // openNotificationWithIcons("系统提示","获取失败。", 'error');
     }
   }
 });

//消息提醒弹窗
const openNotificationWithIcons = (title, desc, type) => {
	let _type = type;
	if (!type) {
		if (desc.indexOf('成功') > -1) {
			_type = 'success';
		} else if (desc.indexOf('错误') > -1 || desc.indexOf('失败') > -1) {
			_type = 'error';
		} else {
			_type = 'info';
		}
	}
	notification.config({
    placement: 'topRight',
    top:79,
  });
  notification[_type]({
    message: title || '系统提示',
    description: desc || '未知消息！',
  });

};

//显示消息弹窗
Object.defineProperty(Utils, 'showMessageDialog', {
	value: function(title,content,type){
		openNotificationWithIcons(title, content, type);
	}
});

//根据状态获取相应颜色
Object.defineProperty(Utils, 'getStatusColor', {
	value: function(status){
    let color = '';
		switch (status) {
      case 'good':
        color = '#00cc00';
        break;
      case 'warning':
        color = '#ffa500';
        break;
      case 'error':
        color = '#d81e06';
        break;
      case 'disabled':
        color = '#d6204b';
        break;
      default:
        color: '#2c2c2c';
        break;
    }
    return color;
	}
});

//将毫秒数转为分秒
Object.defineProperty(Utils, 'MillisecondToDate', {
	value: function(msd){
    var value = parseFloat(msd) / 1000;
    var unit = "";
    if (null != value && "" != value) {
        if (value > 60 && value < 60 * 60) {  //大于1分钟并且小于一小时
            var minutes = parseInt(value / 60.0);
            var seconds = parseInt((parseFloat(value / 60.0) - parseInt(value / 60.0)) * 60);
            value = minutes;
            unit = "分钟";
        } else if (value >= 60 * 60 && value < 60 * 60 * 24) { //大于等于1小时并且小于一天
            var hours = parseInt(value / 3600.0);
            var minutes = parseInt((parseFloat(value / 3600.0) - parseInt(value / 3600.0)) * 60);
            var seconds = parseInt((parseFloat((parseFloat(value / 3600.0) - parseInt(value / 3600.0)) * 60) - parseInt((parseFloat(value / 3600.0) - parseInt(value / 3600.0)) * 60)) * 60);
            if (hours > 0) {
              minutes += hours * 60;
            }
            value = minutes;
            unit = "分钟";
        } else if(value <= 60) { //小于等于一分钟
            if(value == 60){
              value = 1;
              unit = "分钟";
            } else {
              value = parseInt(value);
              unit = "秒钟";
            }
        } else {  //大于一天
          value = parseInt(value / (60 * 60 * 24));
          unit = "天";
        }
    }
    return { value, unit };
	}
});
//将毫秒数转为时分秒
Object.defineProperty(Utils, 'MillisecondToDates', {
	value: function(msd){
    var time = parseFloat(msd) / 1000;
    if (null != time && "" != time) {
        if (time > 60 && time < 60 * 60) {
            time = parseInt(time / 60.0) + "分钟" + parseInt((parseFloat(time / 60.0) -
                parseInt(time / 60.0)) * 60) + "秒";
        } else if (time >= 60 * 60 && time < 60 * 60 * 24) {
            time = parseInt(time / 3600.0) + "小时" + parseInt((parseFloat(time / 3600.0) -
                parseInt(time / 3600.0)) * 60) + "分钟" +
                parseInt((parseFloat((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) -
                parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60)) * 60) + "秒";
        } else {
            time = parseInt(time) + "秒";
        }
    }
    return time;
	}
});

//判断对象是否为数组类型
Object.defineProperty(Utils, 'isArray', {
	value: function(o){
		return Object.prototype.toString.call(o)=='[object Array]';
	}
});

// 判断字符串中是否包含中文字符
Object.defineProperty(Utils, 'checkContainChinese', {
	value: function(val) {
    var reg = new RegExp("[\\u4E00-\\u9FFF]+","g");
    return reg.test(val);
	}
});

// 转换信息数据里的时间格式
Object.defineProperty(Utils, 'parseInfoDateTime', {
	value: function(dateTime) {
		var createdDateTime = "";
		if(dateTime) {
			var _dateTime = new Date(parseInt(dateTime.substring(6, (dateTime.length - 2))));
			createdDateTime = _dateTime.Format("yyyy-MM-dd HH:mm");
		}
		return createdDateTime;
	}
});

// 生成uuid
Object.defineProperty(Utils, 'guid', {
	value: function() {
		return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
	}
});

//用于生成uuid
function S4() {
    return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
}
function guid() {
    return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
}

//处理监测器描述 国际化内容
Object.defineProperty(Utils, 'formatMonitorNls', {
	value: function(monitors, thresholdList) {
    let monitorsStatus = [monitors.length, 0, 0, 0, 0];
    let monitorsStore = Object.assign(monitors, {});
    monitorsStore.forEach((monitorItem) => {
      let { MonitorValue, MonitorType, MonitorStatus, IsDisabled } = monitorItem;
      if (IsDisabled) {
        monitorsStatus[4]++;
      } else {
        //计算各状态数
        switch (MonitorStatus) {
          case 'good':
            monitorsStatus[1]++;
            break;
          case 'warning':
            monitorsStatus[2]++;
            break;
          case 'error':
            monitorsStatus[3]++;
            break;
          case 'disabled':
            monitorsStatus[4]++;
            break;
          default:
        }
      }
      if (MonitorValue) {
        //国际化 返回值 处理
        let monitorValues = handerArray(MonitorValue);
        monitorValues.forEach((monitorValueItem)=>{
          let key = nls[monitorValueItem.alias] || monitorValueItem.alias;
          if (MonitorType == 'SnmpGigabitInterface') {
            if (monitorValueItem.alias == 'IF_INOCTET_SPEED') {
              key = '接收速率(Mbit/s)';
            } else if (monitorValueItem.alias == 'IF_OUTOCTET_SPEED') {
              key = '发送速率(Mbit/s)';
            }
          }
          if (key) {
            const { name, indexS } = handlerEquTitle(key);
            Object.assign(monitorValueItem, { key: key, unit: name, key2: key.substring(0, indexS) });
          }
        });
        monitorItem.Monitor = monitorValues;
        let { Monitor, LastStatusEntry } = handlerMonitorStatus(monitorItem, thresholdList);
        monitorItem.Monitor = Monitor;
        monitorItem.LastStatusEntry = LastStatusEntry;
      } else {
        monitorItem.Monitor = [];
      }
    });
		return { monitorsStore, monitorsStatus };
	}
});

/**将key=value,key=value字符串结构解析成数组 */
function handerArray(paramStr, zhParam, callback) {
  if (paramStr) {
    let paramArr = paramStr.split(',');
    let dataList = [];
    for (let i = 0; i < paramArr.length; i++) {
      let obj = {};
      const index = paramArr[i].indexOf('=');
      let key = paramArr[i].substring(0, index);
      const value = paramArr[i].substring(index + 1);
      obj['alias'] = key;
      obj['value'] = value;
      dataList.push(obj)
    }
    return dataList
  }
}

function handlerEquTitle(title) {
  if (title) {
    let name = title;
    const indexS = title.indexOf('(');
    const idnexE = title.indexOf(')');
    name = name.substring(indexS + 1, idnexE);
    return { name, indexS }
  } else {
    return { name: '', indexS: 0 }
  }
}

/** monitorValue的具体状态 */
function handlerMonitorStatus(param, thresholdList) {
    let { Monitor, MonitorStatus, RecId } = param;
    let LastStatusEntry = "";
    if (MonitorStatus != 'good') {
        if (thresholdList && thresholdList.length > 0) {
            Monitor.forEach((itemM, i) => {
                const { alias, value } = itemM;
                for(let n=0; n < thresholdList.length; n++){
                  let { ReturnValue, Operator, AlramValue, MonitorId, AlarmStatus } = thresholdList[n];
                  if (MonitorId === RecId && alias === ReturnValue) {
                    //与阀值模板进行比对
                    if (handlerMonitorByAlarm(value, Operator, AlramValue) && AlarmStatus==MonitorStatus) {
                        Object.assign(Monitor[i], { "status": AlarmStatus });
                        LastStatusEntry = ReturnValue;
                        break;
                    }
                  }
                }
            });
        }
    }
    return { Monitor, LastStatusEntry };
}

const OPERATE = ['==', '!=', '>=', '>', '<=', '<', 'contains', '!contains'];

//阈值模板匹配
function handlerMonitorByAlarm(value, operate, compareValue) {
    let status = false;
    let _value, _compareValue;
		if (isNaN(Number(value))) {
			_value = value;
      if (!isNaN(Number(compareValue))) {
        return true;
      }
		} else {
			_value = Number(value);
		}
		if (isNaN(Number(compareValue))) {
			_compareValue = compareValue;
		} else {
			_compareValue = Number(compareValue);
		}
    switch (operate) {
        case OPERATE[0]:
            if (_value == _compareValue) {
                status = true
            }
            return status;
        case OPERATE[1]:
            if (_value != _compareValue) {
                status = true
            }
            return status;
        case OPERATE[2]:
            if (_value >= _compareValue) {
                status = true
            }
            return status;
        case OPERATE[3]:
            if (_value > _compareValue) {
                status = true
            }
            return status;
        case OPERATE[4]:
            if (_value <= _compareValue) {
                status = true
            }
            return status;
        case OPERATE[5]:
            if (_value < _compareValue) {
                status = true
            }
            return status;
        case OPERATE[6]:
            if (value.match(compareValue)) {
                status = true
            }
            return status;
        case OPERATE[7]:
            if (!value.match(compareValue)) {
                status = true
            }
            return status;
        default:
            return false
    }
}

Object.defineProperty(Utils, 'handerArray', {
	value: function(text) {
    return handerArray(text);
	}
});

Object.defineProperty(Utils, 'formatAlarmText', {
	value: function(monitorAlarmData) {
    var monitorAlarmText = "";
    //按与或关系排序，先与后或
    monitorAlarmData.sort(function(a,b){
      return a.conditionRelation>b.conditionRelation ? 1 : -1;
    });
    for (var i = 0; i < monitorAlarmData.length; i++) {
      if(i == 0) {
        monitorAlarmText += monitorAlarmData[i].conditionName + " " + monitorAlarmData[i].conditionSymbol + " " + monitorAlarmData[i].conditionValue;
      }
      else {
        monitorAlarmText += (monitorAlarmData[i].conditionRelation==""||monitorAlarmData[i].conditionRelation=="0" ? " 与 " : " 或 ") + monitorAlarmData[i].conditionName + " " + monitorAlarmData[i].conditionSymbol + " " + monitorAlarmData[i].conditionValue;
      }
    }
    return monitorAlarmText;
	}
});

Object.defineProperty(Utils, 'replaceFirstUpper', {
	value: function(str) {
    return str.replace(/\b(\w)|\s(\w)/g, function(m){
        return m.toUpperCase();
    });
	}
});

Object.defineProperty(Utils, 'parseFilterOptions', {
	value: function(filter) {
    let _option = '';
    filter.length && filter.map(function(obj, i) {
      if (i == 0) {
        _option += obj.key + " eq '" + obj.value + "'";
      } else {
        _option += " and " + obj.key + " eq '" + obj.value + "'";
      };
    });
    return _option;
	}
});

//把平行结构的的数据整理成层级树形结构的。
Object.defineProperty(Utils, 'formatTreeData', {
	value: function(deviceMonitorTreeData) {
    let rootArr = [];
    let deviceMonitorTreeMap = {
      se: {
        id: 'se',
        name: 'IT资源树',
        type: 'root',
        children: [],
        eTotalCount: 0,
        eGoodCount: 0,
        eErrorCount: 0,
        eWarningCount: 0,
        eDisableCount: 0,
        mTotalCount: 0,
        mGoodCount: 0,
        mWarningCount: 0,
        mErrorCount: 0,
        mDisableCount: 0
      }
    };
    getParseMonitorTreeData(rootArr, deviceMonitorTreeData, deviceMonitorTreeMap);
    return { rootArr, deviceMonitorTreeMap };
	}
});

//整理树数据
function getParseMonitorTreeData(rootArr, deviceMonitorTreeData, deviceMonitorTreeMap) {
  // 临时防护：防止栈溢出（定位用）
  if (!getParseMonitorTreeData._depth) getParseMonitorTreeData._depth = 0;
  getParseMonitorTreeData._depth++;
  if (getParseMonitorTreeData._depth > 500) {
    console.error('[getParseMonitorTreeData] 深度超500，栈溢出防护！rootArr.length=', rootArr.length, 'data.length=', deviceMonitorTreeData.length);
    getParseMonitorTreeData._depth--;
    return;
  }
  if (rootArr.length <= 0) {
    deviceMonitorTreeData.forEach((item, i) => {
      if (item.ParentGroupId === '') {
        item.id = item.RecId, item.pid = item.ParentGroupId;
        item.type = 'group';
        let {
          childrens,
          _eGoodCount,
          _eErrorCount,
          _eWarningCount,
          _eDisableCount,
          _mTotalCount_1,
          _mGoodCount_1,
          _mWarningCount_1,
          _mErrorCount_1,
          _mDisableCount_1
        } = parseEquipmentData(item.GroupEquipment, deviceMonitorTreeMap);
        let newItem = Object.assign(
          {},
          {
            text: item.GroupName,
            name: item.GroupName,
            children: childrens,
            eTotalCount: childrens.length,
            eGoodCount: _eGoodCount,
            eErrorCount: _eErrorCount,
            eWarningCount: _eWarningCount,
            eDisableCount: _eDisableCount,
            mTotalCount: _mTotalCount_1,
            mGoodCount: _mGoodCount_1,
            mWarningCount: _mWarningCount_1,
            mErrorCount: _mErrorCount_1,
            mDisableCount: _mDisableCount_1,
            iconUrl: getTreeNodeIconUrl(item),
            leaf:true,
          },
          item
        );
        deviceMonitorTreeMap[newItem.RecId] = newItem;
        deviceMonitorTreeMap['se'].children.push(newItem);
        reParseGroupCount(newItem, {
          eTotalCount: childrens.length,
          eGoodCount: _eGoodCount,
          eErrorCount: _eErrorCount,
          eWarningCount: _eWarningCount,
          eDisableCount: _eDisableCount,
          mTotalCount: _mTotalCount_1,
          mGoodCount: _mGoodCount_1,
          mWarningCount: _mWarningCount_1,
          mErrorCount: _mErrorCount_1,
          mDisableCount: _mDisableCount_1,
        }, deviceMonitorTreeMap);
        rootArr.push(newItem);
      }
    });
    // 只有找到了根节点（rootArr 非空）才继续递归处理子层级；
    // 否则说明数据中没有 ParentGroupId==='' 的根节点，直接结束避免无限递归
    if (rootArr.length > 0) {
      getParseMonitorTreeData(rootArr, deviceMonitorTreeData, deviceMonitorTreeMap);
    }
  } else {
    rootArr.forEach(childObj => {
      deviceMonitorTreeData.forEach(dt => {
        if (childObj.RecId === dt.ParentGroupId) {
          dt.id = dt.RecId, dt.pid = dt.ParentGroupId;
          dt.type = 'group';
          let {
            childrens,
            _eGoodCount,
            _eErrorCount,
            _eWarningCount,
            _eDisableCount,
            _mTotalCount_1,
            _mGoodCount_1,
            _mWarningCount_1,
            _mErrorCount_1,
            _mDisableCount_1
          } = parseEquipmentData(dt.GroupEquipment, deviceMonitorTreeMap);
          let newItem = Object.assign(
            {},
            {
              text: dt.GroupName,
              name: dt.GroupName,
              children: childrens,
              eTotalCount: childrens.length,
              eGoodCount: _eGoodCount,
              eErrorCount: _eErrorCount,
              eWarningCount: _eWarningCount,
              eDisableCount: _eDisableCount,
              mTotalCount: _mTotalCount_1,
              mGoodCount: _mGoodCount_1,
              mWarningCount: _mWarningCount_1,
              mErrorCount: _mErrorCount_1,
              mDisableCount: _mDisableCount_1,
              iconUrl: getTreeNodeIconUrl(dt),
              leaf:true,
            },
            dt
          );
          deviceMonitorTreeMap[newItem.RecId] = newItem;
          childObj.children.push(newItem);
          reParseGroupCount(newItem, {
            eTotalCount: childrens.length,
            eGoodCount: _eGoodCount,
            eErrorCount: _eErrorCount,
            eWarningCount: _eWarningCount,
            eDisableCount: _eDisableCount,
            mTotalCount: _mTotalCount_1,
            mGoodCount: _mGoodCount_1,
            mWarningCount: _mWarningCount_1,
            mErrorCount: _mErrorCount_1,
            mDisableCount: _mDisableCount_1,
          }, deviceMonitorTreeMap);
        }
      });
      if(childObj.children.length>0){
        childObj.leaf = false;
        getParseMonitorTreeData(childObj.children, deviceMonitorTreeData, deviceMonitorTreeMap);
      }
    });
  }
  getParseMonitorTreeData._depth--;
}

//反向累计组各统计数据
function reParseGroupCount(item, countObj, deviceMonitorTreeMap) {
  let parentItem = deviceMonitorTreeMap[item.pid || 'se'];
  parentItem.eTotalCount += countObj.eTotalCount;
  parentItem.eGoodCount += countObj.eGoodCount;
  parentItem.eErrorCount += countObj.eErrorCount;
  parentItem.eWarningCount += countObj.eWarningCount;
  parentItem.eDisableCount += countObj.eDisableCount;
  parentItem.mTotalCount += countObj.mTotalCount;
  parentItem.mGoodCount += countObj.mGoodCount;
  parentItem.mWarningCount += countObj.mWarningCount;
  parentItem.mErrorCount += countObj.mErrorCount;
  parentItem.mDisableCount += countObj.mDisableCount;
  if (item.pid) {
    reParseGroupCount(parentItem, countObj, deviceMonitorTreeMap);
  }
}

function parseEquipmentData(GroupEquipment, deviceMonitorTreeMap) {
  let childrens = [];
  let _eGoodCount=0,_eErrorCount=0,_eWarningCount=0,_eDisableCount=0,_mTotalCount_1=0,_mGoodCount_1=0,_mWarningCount_1=0,_mErrorCount_1=0,_mDisableCount_1=0;
  if(GroupEquipment){
    GroupEquipment.forEach(item => {
      if (item.EquipmentStatus === 'good') {
        _eGoodCount++;
      } else if (item.EquipmentStatus === 'error') {
        _eErrorCount++;
      } else if (item.EquipmentStatus === 'warning') {
        _eWarningCount++;
      } else if (item.EquipmentStatus === 'disabled') {
        _eDisableCount++;
      }
      let { _childrens, _mGoodCount, _mWarningCount, _mErrorCount, _mDisableCount } = parseMonitorData(item.EquipmentMonitor, deviceMonitorTreeMap);
      _mTotalCount_1 += _childrens.length;
      _mGoodCount_1 += _mGoodCount;
      _mWarningCount_1 += _mWarningCount;
      _mErrorCount_1 += _mErrorCount;
      _mDisableCount_1 += _mDisableCount;

      item.id = item.RecId, item.pid = item.GroupId;
      item.type = 'equipment';
      // 编辑资源时 CreateResourceWindow_* 依赖 selectedResource.EqName 取类型短名，
      // 树节点原本只有 EquipmentType/eqType，这里补齐 EqName（与新建资源下拉数据一致）
      // eqType 优先取设备真实类型码（适配层透传的 equipType，如 Equipment.Windows），
      // 供新增监测器时按 /monitor/types 的 equipType 过滤模板；兜底用旧拼接
      item.eqType = item.equipType || (item.EquipmentType ? 'Equipment.' + item.EquipmentType : (item.eqType || ''));
      item.EqName = item.EquipmentType || (item.eqType ? item.eqType.replace('Equipment.', '') : '');
      let newItem = Object.assign(
        {},
        {
          text: item.Title,
          name: item.Title,
          children: _childrens,
          mTotalCount: _childrens.length,
          mGoodCount: _mGoodCount,
          mWarningCount: _mWarningCount,
          mErrorCount: _mErrorCount,
          mDisableCount: _mDisableCount,
          leaf: true,
          iconUrl: getTreeNodeIconUrl(item),
        },
        item
      );
      deviceMonitorTreeMap[newItem.RecId] = newItem;
      childrens.push(newItem);
    });
  }
  return { childrens, _eGoodCount, _eErrorCount, _eWarningCount, _eDisableCount, _mTotalCount_1, _mGoodCount_1, _mWarningCount_1, _mErrorCount_1, _mDisableCount_1 };
}

function parseMonitorData(monitor, deviceMonitorTreeMap) {
  let _childrens = [];
  let _mGoodCount=0, _mWarningCount=0, _mErrorCount=0, _mDisableCount=0;
  if(monitor){
    monitor.forEach(item => {
      if (item.IsDisabled) {
        _mDisableCount++;
      } else {
        switch (item.MonitorStatus) {
          case 'good':
            _mGoodCount++;
            break;
          case 'warning':
            _mWarningCount++;
            break;
          case 'error':
            _mErrorCount++;
            break;
          case 'disabled':
            _mDisableCount++;
            break;
          default:
        }
      }
      item.id = item.RecId, item.pid = item.EquipmentId;
      item.type = 'monitor';
      let newItem = Object.assign(
        {},
        {
          text: item.Title,
          name: item.Title,
          children: [],
          leaf: false,
          // iconUrl: this.getTreeNodeIconUrl(item),
        },
        item
      );
      deviceMonitorTreeMap[newItem.RecId] = newItem;
      _childrens.push(newItem);
    });
  }
  return { _childrens, _mGoodCount, _mWarningCount, _mErrorCount, _mDisableCount };
}

function getTreeNodeIconUrl(treeNode) {
  var dataNodeType = treeNode.type;
  var dataNodeStatus = treeNode.Status || treeNode.EquipmentStatus;
  var dataNodeInd = dataNodeType.indexOf("equipment");
  var curIconUrl = "./public/img/itoss/";
  if(dataNodeType == "dvr"){
    curIconUrl += "DVR_png";
  }else if(dataNodeType == "nvr"){
    curIconUrl += "NVR_png";
  }else if(dataNodeType == "ipsan"){
    curIconUrl += "IPSAN_png";
  }else if(dataNodeType == "vedio"){
    curIconUrl += "Qj_png";
  }else if(dataNodeType == "code"){
    curIconUrl += "CODE_png";
  }else{
    if(dataNodeInd<0){
      curIconUrl += "group";
    }else{
      curIconUrl += "entity"
    };
    curIconUrl += dataNodeStatus + '.png';
  };
  return curIconUrl;
}

//把平行结构的的数据整理成层级树形结构的数据。
Object.defineProperty(Utils, 'formatTreeMapData', {
	value: function(deviceMonitorTreeData) {
    let treeData = [];
    let deviceMonitorTreeMap = {
      se: {
        id: 'se',
        name: 'IT资源树',
        type: 'root',
        children: [],
        eTotalCount: 0,
        eGoodCount: 0,
        eErrorCount: 0,
        eWarningCount: 0,
        eDisableCount: 0,
        mTotalCount: 0,
        mGoodCount: 0,
        mWarningCount: 0,
        mErrorCount: 0,
        mDisableCount: 0
      }
    };
    getParseMonitorTreeMapData(treeData, deviceMonitorTreeData, deviceMonitorTreeMap);
    return { treeData, deviceMonitorTreeMap };
	}
});

//整理树数据
function getParseMonitorTreeMapData(treeData, deviceMonitorTreeData, deviceMonitorTreeMap) {
  if (treeData.length <= 0) {
    deviceMonitorTreeData.forEach((item, i) => {
      if (item.ParentGroupId === '') {
        item.id = item.RecId, item.pid = item.ParentGroupId;
        item.type = 'group';
        let {
          childrens,
          _eGoodCount,
          _eErrorCount,
          _eWarningCount,
          _eDisableCount,
          _mTotalCount_1,
          _mGoodCount_1,
          _mWarningCount_1,
          _mErrorCount_1,
          _mDisableCount_1
        } = parseEquipmentMapData(item.GroupEquipment, deviceMonitorTreeMap);
        let newItem = Object.assign(
          {},
          {
            text: item.GroupName,
            name: item.GroupName,
            value: childrens.length,
            itemStyle: {
              borderColor: '#0b2838',
              color: '#0b2838',
              borderWidth: childrens.length? 5 : 0,
            },
            children: childrens,
            eTotalCount: childrens.length,
            eGoodCount: _eGoodCount,
            eErrorCount: _eErrorCount,
            eWarningCount: _eWarningCount,
            eDisableCount: _eDisableCount,
            mTotalCount: _mTotalCount_1,
            mGoodCount: _mGoodCount_1,
            mWarningCount: _mWarningCount_1,
            mErrorCount: _mErrorCount_1,
            mDisableCount: _mDisableCount_1,
            leaf:true,
          },
          item
        );
        deviceMonitorTreeMap[newItem.RecId] = newItem;
        deviceMonitorTreeMap['se'].children.push(newItem);
        reParseGroupCount(newItem, {
          eTotalCount: childrens.length,
          eGoodCount: _eGoodCount,
          eErrorCount: _eErrorCount,
          eWarningCount: _eWarningCount,
          eDisableCount: _eDisableCount,
          mTotalCount: _mTotalCount_1,
          mGoodCount: _mGoodCount_1,
          mWarningCount: _mWarningCount_1,
          mErrorCount: _mErrorCount_1,
          mDisableCount: _mDisableCount_1,
        }, deviceMonitorTreeMap);
        treeData.push(newItem);
      }
    });
    getParseMonitorTreeMapData(treeData, deviceMonitorTreeData, deviceMonitorTreeMap);
  } else {
    treeData.forEach(childObj => {
      deviceMonitorTreeData.forEach(dt => {
        if (childObj.RecId === dt.ParentGroupId) {
          dt.id = dt.RecId, dt.pid = dt.ParentGroupId;
          dt.type = 'group';
          let {
            childrens,
            _eGoodCount,
            _eErrorCount,
            _eWarningCount,
            _eDisableCount,
            _mTotalCount_1,
            _mGoodCount_1,
            _mWarningCount_1,
            _mErrorCount_1,
            _mDisableCount_1
          } = parseEquipmentMapData(dt.GroupEquipment, deviceMonitorTreeMap);
          let newItem = Object.assign(
            {},
            {
              text: dt.GroupName,
              name: dt.GroupName,
              value: childrens.length,
              itemStyle: {
                borderColor: '#0b2838',
                color: '#0b2838',
                borderWidth: childrens.length? 5 : 0,
              },
              children: childrens,
              eTotalCount: childrens.length,
              eGoodCount: _eGoodCount,
              eErrorCount: _eErrorCount,
              eWarningCount: _eWarningCount,
              eDisableCount: _eDisableCount,
              mTotalCount: _mTotalCount_1,
              mGoodCount: _mGoodCount_1,
              mWarningCount: _mWarningCount_1,
              mErrorCount: _mErrorCount_1,
              mDisableCount: _mDisableCount_1,
              leaf:true,
            },
            dt
          );
          deviceMonitorTreeMap[newItem.RecId] = newItem;
          childObj.children.push(newItem);
          reParseGroupCount(newItem, {
            eTotalCount: childrens.length,
            eGoodCount: _eGoodCount,
            eErrorCount: _eErrorCount,
            eWarningCount: _eWarningCount,
            eDisableCount: _eDisableCount,
            mTotalCount: _mTotalCount_1,
            mGoodCount: _mGoodCount_1,
            mWarningCount: _mWarningCount_1,
            mErrorCount: _mErrorCount_1,
            mDisableCount: _mDisableCount_1,
          }, deviceMonitorTreeMap);
        }
      });
      if(childObj.children.length>0){
        childObj.leaf = false;
        getParseMonitorTreeMapData(childObj.children, deviceMonitorTreeData, deviceMonitorTreeMap);
      }
    });
  }
}

function parseEquipmentMapData(GroupEquipment, deviceMonitorTreeMap) {
  let childrens = [];
  let _eGoodCount=0,_eErrorCount=0,_eWarningCount=0,_eDisableCount=0,_mTotalCount_1=0,_mGoodCount_1=0,_mWarningCount_1=0,_mErrorCount_1=0,_mDisableCount_1=0;
  if(GroupEquipment){
    GroupEquipment.forEach(item => {
      if (item.EquipmentMonitor.length) {
        if (item.EquipmentStatus === 'good') {
          _eGoodCount++;
        } else if (item.EquipmentStatus === 'error') {
          _eErrorCount++;
        } else if (item.EquipmentStatus === 'warning') {
          _eWarningCount++;
        } else if (item.EquipmentStatus === 'disabled') {
          _eDisableCount++;
        }
        let { _childrens, _mGoodCount, _mWarningCount, _mErrorCount, _mDisableCount } = parseMonitorMapData(item.EquipmentMonitor, deviceMonitorTreeMap);
        _mTotalCount_1 += _childrens.length;
        _mGoodCount_1 += _mGoodCount;
        _mWarningCount_1 += _mWarningCount;
        _mErrorCount_1 += _mErrorCount;
        _mDisableCount_1 += _mDisableCount;

        item.id = item.RecId, item.pid = item.GroupId;
        item.type = 'equipment', item.eqType = 'Equipment.' + item.EquipmentType;
        let newItem = Object.assign(
          {},
          {
            text: item.Title,
            name: item.Title,
            value: _childrens.length?_childrens.length: 1,
            itemStyle: {
              borderColor: '#4b4e45',
              borderWidth: _childrens.length? 5 : 0,
              color: '#4b4e45'
            },
            children: _childrens,
            mTotalCount: _childrens.length,
            mGoodCount: _mGoodCount,
            mWarningCount: _mWarningCount,
            mErrorCount: _mErrorCount,
            mDisableCount: _mDisableCount,
            leaf: true,
          },
          item
        );
        deviceMonitorTreeMap[newItem.RecId] = newItem;
        childrens.push(newItem);
      }
    });
  }
  return { childrens, _eGoodCount, _eErrorCount, _eWarningCount, _eDisableCount, _mTotalCount_1, _mGoodCount_1, _mWarningCount_1, _mErrorCount_1, _mDisableCount_1 };
}

function parseMonitorMapData(monitor, deviceMonitorTreeMap) {
  let _childrens = [];
  let _mGoodCount=0, _mWarningCount=0, _mErrorCount=0, _mDisableCount=0;
  if(monitor){
    monitor.forEach(item => {
      let _color = '#00cc00';
      if (item.IsDisabled) {
        _mDisableCount++;
        _color = '#ccc';
      } else {
        switch (item.MonitorStatus) {
          case 'good':
            _mGoodCount++;
            break;
          case 'warning':
            _mWarningCount++;
            _color = '#ffa500';
            break;
          case 'error':
            _mErrorCount++;
            _color = '#d81e06';
            break;
          case 'disabled':
            _mDisableCount++;
            _color = '#ccc';
            break;
          default:
        }
      }
      item.id = item.RecId, item.pid = item.EquipmentId;
      item.type = 'monitor';
      let newItem = Object.assign(
        {},
        {
          text: item.Title,
          name: item.Title,
          value: 1,
          itemStyle: {
            borderWidth: 0,
            color: _color
          },
          children: [],
          leaf: false,
        },
        item
      );
      deviceMonitorTreeMap[newItem.RecId] = newItem;
      _childrens.push(newItem);
    });
  }
  return { _childrens, _mGoodCount, _mWarningCount, _mErrorCount, _mDisableCount };
}

// 转换对象的key为小写
Object.defineProperty(Utils, 'parseObjectKeyToLowercase', {
	value: function(obj) {
    const _keys = Object.keys(obj);
    const lowerObj = {};
    _keys.map((key) => {
      lowerObj[key.toLowerCase()] = obj[key];
    });
    return lowerObj;
	}
});

// 比较IP地址大小
Object.defineProperty(Utils, 'compareIpAddress', {
	value: function(ipBegin, ipEnd) {
    var temp1;  
    var temp2;    
    temp1 = ipBegin.split(".");  
    temp2 = ipEnd.split(".");     
    for (var i = 0; i < 4; i++) {  
      if (parseInt(temp1[i])>parseInt(temp2[i])) {  
        return 1;  
      } else if (parseInt(temp1[i])<parseInt(temp2[i])) {  
        return -1;  
      }  
    }  
    return 0; 
	}
});
/**数组根据数组对象中的某个属性值进行排序的方法
* 使用例子：newArray.sort(sortBy('number',false)) //表示根据number属性降序排列;若第二个参数不传递，默认表示升序排序
* @param attr 排序的属性 如number属性
* @param rev true表示升序排列，false降序排序
* */
Object.defineProperty(Utils, 'sortBy', {
	value: function(attr, rev) {
    //第二个参数没有传递 默认升序排列
    if(rev ==  undefined){
      rev = 1;
    }else{
      rev = (rev) ? 1 : -1;
    }
    return function(a,b){
      a = a[attr];
      b = b[attr];
      if(a < b){
        return rev * -1;
      }
      if(a > b){
        return rev * 1;
      }
      return 0;
    }
	}
});

// 转换对象的key为小写
Object.defineProperty(Utils, 'getFilterStatusTypes', {
	value: function(obj) {
    return {total: '全部', error: '错误', warning: '危险', good: '正常', disabled: '禁止'};
	}
});

// 可排序ip格式: 192.168.1.1, 192.168.1.0/23
Object.defineProperty(Utils, 'sortIPAddress', {
   value: function(a, b){
     if(a == '') a = '0.0.0.0';
     if(b == '') b = '0.0.0.0';
     var ip_array_1 = a.split('.');
     var ip_array_2 = b.split('.');
     if(parseInt(ip_array_1[0]) > parseInt(ip_array_2[0])) {
       return 1;
     } else if (parseInt(ip_array_1[0]) < parseInt(ip_array_2[0])) {
       return -1;
     }

     if (parseInt(ip_array_1[0]) == parseInt(ip_array_2[0])) {
       if(parseInt(ip_array_1[1]) > parseInt(ip_array_2[1])) {
         return 1;
       } else if (parseInt(ip_array_1[1]) < parseInt(ip_array_2[1])) {
         return -1;
       }

       if (parseInt(ip_array_1[1]) == parseInt(ip_array_2[1])) {
         if(parseInt(ip_array_1[2]) > parseInt(ip_array_2[2])) {
           return 1;
         } else if (parseInt(ip_array_1[2]) < parseInt(ip_array_2[2])) {
           return -1;
         }

         if (parseInt(ip_array_1[2]) == parseInt(ip_array_2[2])) {

           var last_arr_1 = ip_array_1[3].split('/'), last_arr_2 = ip_array_2[3].split('/');
           var str_1 = last_arr_1[0], str_2 = last_arr_2[0];
           if(parseInt(str_1) > parseInt(str_2)) {
             return 1;
           } else if (parseInt(str_1) < parseInt(str_2)) {
             return -1;
           }
           if (last_arr_1.length == 1 && last_arr_2.length == 1 && parseInt(str_1) == parseInt(str_2)) {
             return 0;
           }
           var last_str_1 = '0', last_str_2 = '0';
           if (last_arr_1.length > 1) {
             last_str_1 = last_arr_1[1];
           }
           if (last_arr_2.length > 1) {
             last_str_2 = last_arr_2[1];
           }
           if(parseInt(last_str_1) > parseInt(last_str_2)) {
             return 1;
           } else if (parseInt(last_str_1) < parseInt(last_str_2)) {
             return -1;
           } else {
             return 0;
           }
         }
       }
     }
  }
});

//判断是否拥有权限
Object.defineProperty(Utils, 'hasPermission', {
  value: function(type, action){
    var currentRole = Store.get("CURRENT_ROLENAME");
    if (currentRole == '管理员') {
      return true;
    }
    // 开发期：admin 账号默认放行所有菜单（后端权限接口尚未对接完整）
    if (Store.get('USERNAME') == 'admin' || Store.get('localUserName') == 'admin') {
      return true;
    }
    var permissions = Store.get("PERMISSIONS") || '';
    var _permission = Utils.getPermissionPrefix(type, action);
    // console.log(_permission);
    if(!permissions || !_permission) return false;
    permissions = Base64.base64decode(permissions);
    permissions = decodeURI(permissions);
    var permissionsValue = permissions.split(',');
    if (type == '/system') {
      // 系统设置时排除用户角色管理下修改密码，个人信息权限判断
      const passPers = ['/system', '/system/userrole', '/system/userrole/updatepwd'];
      return permissionsValue.find(item => passPers.indexOf(item) == -1 && item.indexOf('/system/userrole/personal') == -1 && item.indexOf('/system') > -1) ? true : false;
    }
    return permissionsValue.indexOf(_permission) > -1 ? true : false;
  }
});

//获取权限前缀, action=undefined, type为权限Type
Object.defineProperty(Utils, 'getPermissionPrefix', {
  value: function(type, action){
    if (action == undefined) {
      return type;
    }
    let prefix = '';
    switch (type) {
      case 'tree':
        prefix = '/sam/resource';
        break;
      case 'group':
        prefix = '/sam/resource/eccgroup';
        break;
      case 'equipment':
        prefix = '/sam/resource/eccgroup/equipment';
        break;
      case 'monitor':
        prefix = '/sam/resource/eccgroup/equipment/monitor';
        break;
      case 'topo':
        prefix = '/sam/3dtopology';
        break;
      case 'statebatu':
        prefix = '/sam/statebatu';
        break;
      case 'matrixview':
        prefix = '/sam/matrixview';
        break;
      case 'topoNode':
        prefix = '/sam/3dtopology/node';
        break;
      case 'alarmEvent':
        prefix = '/alarm/event';
        break;
      case 'alarmRule':
        prefix = '/alarm/rule';
        break;
      case 'sendLog':
        prefix = '/alarm/sendlog';
        break;
      case 'sendSetup':
        prefix = '/alarm/sendsetup';
        break;
      case 'sendSetupEmail':
        prefix = '/alarm/sendsetup/email';
        break;
      case 'sendSetupSms':
        prefix = '/alarm/sendsetup/sms';
        break;
      case 'report':
        prefix = '/report';
        break;
      case 'reportTopN':
        prefix = '/report/topn';
        break;
      case 'reportError':
        prefix = '/report/error';
        break;
      case 'wechat':
        prefix = '/wechat/service';
        break;
      case 'system':
        prefix = '/system';
        break;
      case 'userrole':
        prefix = '/system/userrole';
        break;
      case 'user':
        prefix = '/system/userrole/user';
        break;
      case 'role':
        prefix = '/system/userrole/role';
        break;
      case 'team':
        prefix = '/system/userrole/team';
        break;
      case 'systemResource':
        prefix = '/system/resources';
        break;
      case 'taskplan':
        prefix = '/system/resources/taskplan';
        break;
      case 'systemRunning':
        prefix = '/system/running';
        break;
      case 'systemImage':
        prefix = '/system/image';
        break;
      case 'systemDatabase':
        prefix = '/system/database';
        break;
      case 'systemDatabaseBackup':
        prefix = '/system/database/backup';
        break;
      case 'systemDatasource':
        prefix = '/system/database/datasource';
        break;
      case 'systemDatabaseLog':
        prefix = '/system/database/log';
        break;
      case 'systemDatabaseUpdate':
        prefix = '/system/database/update/upload';
        break;
      case 'personal':
        prefix = '/system/userrole/personal';
        break;
      case 'systemMaintenance':
        prefix = '/system/maintenance';
        break;
      default:
        break;
    }
    return action ? prefix + '/' + action : prefix;
  }
});

//获取访问IP地址
Object.defineProperty(Utils, 'getLocalIP', {
   value: function(onNewIP){
     var myPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
     if (!myPeerConnection) {
       Utils.getLocalIPAddress();
       onNewIP(Store.get('userLocalIP') || '');
       return;
     }
     var pc = new myPeerConnection({
         iceServers: []
     }),
     noop = function() {},
     localIPs = {},
     ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g,
     key;

     function iterateIP(ip) {
         if (!localIPs[ip]) onNewIP(ip);
         localIPs[ip] = true;
     }

      //create a bogus data channel
     pc.createDataChannel("");

     // create offer and set local description
     pc.createOffer(function(sdp) {
         sdp.sdp.split('\n').forEach(function(line) {
             if (line.indexOf('candidate') < 0) return;
             line.match(ipRegex).forEach(iterateIP);
         });

         pc.setLocalDescription(sdp, noop, noop);
     }, noop);

     //listen for candidate events
     pc.onicecandidate = function(ice) {
         if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return;
         ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
     };
  }
});

// 加载脚本
Object.defineProperty(Utils, 'loadScriptString', {
   value: function(script, code){
     try {
         script.appendChild(document.createTextNode(code));
     } catch (ex) {
         script.text = code;
     }
     document.body.appendChild(script);
  }
});

Object.defineProperty(Utils, 'getLocalIPAddress2', {
   value: function(){
    // if (locator.ConnectServer) {
      var script = document.createElement("script");
    	// script.type = "text/javascript";
      // script.setAttribute('FOR', 'locator');
      // script.setAttribute('EVENT', 'OnCompleted(hResult,pErrorObject, pAsyncContext)');
      // script.setAttribute('LANGUAGE', 'JScript');
    	// var _text = 'console.log("getLocalIPAddress------------------1");var service = locator.ConnectServer();service.Security_.ImpersonationLevel=3;service.InstancesOfAsync(foo, "Win32_NetworkAdapterConfiguration");';
     	// Utils.loadScriptString(script, _text);
      var service = locator.ConnectServer();service.Security_.ImpersonationLevel=3;service.InstancesOfAsync(foo, "Win32_NetworkAdapterConfiguration");
       var script2 = document.createElement("script");
       script2.setAttribute('FOR', 'foo');
       script2.setAttribute('EVENT', 'OnObjectReady(objObject,objAsyncContext)');
       script2.setAttribute('LANGUAGE', 'JScript');
       // console.log(script2);
       //window.localStorage.setItem("userLocalIP",objObject.IPAddress(0))
       var _text2 =
       'if(objObject.IPEnabled != null && objObject.IPEnabled != "undefined" && objObject.IPEnabled == true){' +
         'if(objObject.IPEnabled && objObject.IPAddress(0) !=null && objObject.IPAddress(0) != "undefined" && objObject.DNSServerSearchOrder != null)' +
           'console.log(objObject.IPAddress(0));'+
       '}';
       Utils.loadScriptString(script2, _text2);
    // }
  }
});

Object.defineProperty(Utils, 'getLocalIPAddress', {
   value: function(){
     var locator = null;
     try {
       objCard = new ActiveXObject("WbemScripting.SWbemLocator");
     } catch (e) {
       console.log("调用ActiveX失败！");
     }
     if (!locator) {
       return;
     }
     var service = locator.ConnectServer(".");
     var properties = service.ExecQuery("SELECT * FROM Win32_NetworkAdapterConfiguration");
     var e = new Enumerator (properties);
     for (;!e.atEnd();e.moveNext())
     {
        var p = e.item();
        if (p.IPAddress!=null ) {
            // console.log("IP:",p.IPAddress(0)); //User's IP
            Store.set('userLocalIP', p.IPAddress(0));
            break;
        }
     }
  }
});

Object.defineProperty(Utils, 'authenanceTip', {
   value: "，如需增加点数，请登录 www.siteview.comn，电话 13520830552（彭先生）"
});

Object.defineProperty(Utils, 'NetEquipment', {
  value: ['Network', 'FireWall', 'LoadBalancing', 'WirelessNetwork', 'VPPNDiscovery', 'VppnRouter']
});

/**
 * 查询当前屏幕断点
 */
Object.defineProperty(Utils, 'queryBreakPoint', {
  value: function () {
    let screenWidth = document.documentElement.clientWidth || document.body.clientWidth;
    if (screenWidth > 1250) {
      return 'showLong'
    } else {
      return 'showShort'
    }
  }
})

/**
 * 判断是否小屏
 */
Object.defineProperty(Utils, 'isSmallScreen', {
  value: function (breakPoint) {
    return breakPoint === 'showLong' || breakPoint === 'showShort';
  }
})

Object.defineProperty(Utils, 'isLinux', {
  value: function (osname) {
    return osname === 'linux';
  }
})

export default Utils;
